import { App } from "./app";
new App().boot();